import Block from '@components/Layout/Block';
import { color } from '@design/templateFns';
import { FC } from 'react';
import styled from 'styled-components';

// The structure of this drawer is the same as the ListingHighlights component,
// Using the component directly instead of forking it
// Same styles as Drawers
import {
  DrawerHeader,
  SectionListNoColumn,
} from '@components/PropertyDetailsComponents/Drawer/styles';
import { useTranslations } from 'next-intl';

interface DevelopmentFeaturesAmenitiesProps {
  list: string[];
}

const DevelopmentFeaturesAmenities: FC<DevelopmentFeaturesAmenitiesProps> = ({ list }) => {
  const t = useTranslations();
  return (
    <Block narrow>
      <DrawerHeader>{t('Features & Amenities')}</DrawerHeader>
      <StyledSectionListNoColumn>
        {list.map((item, index) => (
          <li key={index.toString()}>{item}</li>
        ))}
      </StyledSectionListNoColumn>
    </Block>
  );
};

export default DevelopmentFeaturesAmenities;

const StyledSectionListNoColumn = styled(SectionListNoColumn)`
  li {
    color: ${color('fg')};
  }
`;
